module.exports = __webpack_public_path__ + "static/media/power.3b31c8c9.png";